import {gql} from '@apollo/client';

export const itemDataMutations = {
    UPDATE_ITEM_DATA_ORDER_AND_STATUS: gql`
        mutation UpdateItemsOrderAndStatuses(
            $input: [ItemDataUpdateOrderAndStatuesRequestInput!]!
            $draggedItemId: UUID
        ) {
            updateItemsOrderAndStatuses(input: $input, draggedItemId: $draggedItemId) {
                message
                data {
                    draggedItemId
                    prevStatusId
                    newStatusId
                }
                success
                statusCode
            }
        }
    `,

    CREATE_ITEM_DATA: gql`
        mutation CreateItemData($input: ItemDataCreateInput!) {
            createItemData(input: $input) {
                id
                itemStatusId
                order
                summaryViews {
                    value
                    uniqueId
                }
                data {
                    isMultiValue
                    defaultValue {
                        options {
                            label
                            value
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
                url
                ticketNo
            }
        }
    `,
    UPDATE_ITEM_DATA: gql`
        mutation UpdateItemData($input: ItemDataUpdateInput!) {
            updateItemData(input: $input) {
                id
                itemStatusId
                summaryViews {
                    value
                    uniqueId
                }
                itemStatus {
                    boardId
                }
                data {
                    isMultiValue
                    defaultValue {
                        options {
                            label
                            value
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
                sprintId
                url
                ticketNo
                order
            }
        }
    `,
    REMOVE_ITEM_DATAS_BY_IDS: gql`
        mutation RemoveItemDatasByIds($ids: [UUID!]!) {
            removeItemDatasByIds(ids: $ids) {
                message
                data
                success
                statusCode
            }
        }
    `,
    UPDATE_ITEM_STATUS_FOR_ITEM: gql`
        mutation UpdateItemStates($input: UpdateItemStatuesRequestDTOInput!) {
            updateItemStates(input: $input) {
                id
                itemStatusId
            }
        }
    `,
    UPDATE_ITEM_SPRINT_FOR_ITEM: gql`
        mutation UpdateItemSprints($input: UpdateItemSprintRequestDTOInput!) {
            updateItemSprints(input: $input) {
                id
                itemStatusId
            }
        }
    `,
    TRANSFER_ITEMS: gql`
        mutation TransferItems($input: TransferItemsRequestInput!) {
            transferItems(input: $input) {
                id
                itemStatusId
            }
        }
    `,
};
